import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";
import type { Tip } from "@/types/content";

export default function TrendingSection({ list }: { list: Tip[] }) {
  return (
    <section id="trending" className="bg-background-100 py-14 md:py-20" aria-label="本周热榜">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              kicker="大家在聊什么"
              title="本周热榜"
              desc="按阅读与互动量排出的前五条。评论区里往往比正文更热闹，值得点进去看看。"
            />
            <Link
              to="/feed"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              看完整榜单
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>

          <ol className="flex flex-col lg:col-span-8">
            {list.map((tip, index) => {
              const category = categories.find((item) => item.slug === tip.category);
              const isTop = index < 3;
              return (
                <li key={tip.id} className="border-b border-background-200 first:border-t">
                  <Link
                    to={`/detail/${tip.id}`}
                    className="group flex items-start gap-4 py-5 transition-colors md:gap-6"
                  >
                    <span
                      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-display text-lg ${
                        isTop ? "bg-accent-500 text-foreground-950" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="flex min-w-0 flex-1 flex-col">
                      <span className="flex flex-wrap items-center gap-2 font-label text-xs text-foreground-500">
                        <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-secondary-900">
                          {category?.label}
                        </span>
                        <span>{tip.createdAt}</span>
                      </span>
                      <h3 className="mt-2 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                        {tip.title}
                      </h3>
                      <span className="mt-1.5 line-clamp-1 text-sm text-foreground-600">{tip.summary}</span>
                      <span className="mt-2 flex flex-wrap items-center gap-4 font-label text-xs text-foreground-500">
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-eye-line" aria-hidden="true" />
                          {tip.views}
                        </span>
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-heart-3-line" aria-hidden="true" />
                          {tip.likes}
                        </span>
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-user-3-line" aria-hidden="true" />
                          {tip.author}
                        </span>
                      </span>
                    </span>
                  </Link>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}